module.exports = __webpack_public_path__ + "img/073620.9fafbaeb.png";